import { ERR__REFERRALS, GET__REFERRALS, LOADING__REFERRALS } from "../actions/actionTypes";

const initialState = {
    referrals: {},
    loading: false,
    err: false,
    msg: ""
};

export default function referralReducer(state = initialState, { type, payload }) {
    switch (type) {
        case GET__REFERRALS:
            return {
                ...state,
                referrals: {...payload},
                loading: false,
            }

        case LOADING__REFERRALS:
            return {
                ...state,
                loading: true,
            }
        
        case ERR__REFERRALS:
            return {
                ...state,
                loading: false,
                err: true,
                msg: payload,
            }
    
        default:
            return state;
    }
}